module.exports = __webpack_public_path__ + "img/logo.8e6242f2.png";